//import { tWithKeyAttr as t } from "../../i18nHelper";
import React, { ReactNode, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { Category } from "../../types/types";
import useMediaQuery from "../../hooks/useMediaQuery";
import styles from "./mainContentLayout.module.css";
import Sidebar from "../sidebar/sidebar";
import Notifications from "../notifications/notifications";
import CompaniesCombo from "../companiesCombo/CompaniesCombo";
import { mobileWidth, testUserEmail } from "../../utils/constants";
import { getMenuCategories } from "../../utils/categories";
import ModalOverlay from "../modals/modalOverlay/ModalOverlay";
import { useAppSelector } from "../../services/hooks";
import { userSelector } from "../../services/selectors/user.selectors";
import i18n from "../../i18n";

interface IMainContentLayoutProps {
  activeCategory: Category;
  changeCategory: (e: React.MouseEvent, cat: Category) => void;
  children: ReactNode;
}

function MainContentLayout({
  activeCategory,
  changeCategory,
  children,
}: IMainContentLayoutProps) {
  const mobile = useMediaQuery(mobileWidth);
  const initialState = !mobile;
  const [openMenu, setOpenMenu] = useState(initialState);
  const [showNotifications, setShowNotifications] = useState(false);
  const location = useLocation();
  const isForum =
    location.pathname === "/forum" || location.pathname.startsWith("/forum/");
  const therapist = useAppSelector(userSelector);
  const isTestUser = therapist?.email.toLowerCase() === testUserEmail;
  const lang = i18n.language;
  const dir = useMemo(() => {
    return lang === "he" || lang === "ar" ? "rtl" : "ltr";
  }, [lang]);
  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };
  const hideNotifications = () => {
    if (showNotifications) setShowNotifications(false);
  };

  return (
    <main
      dir={dir}
      className={`${styles.main}
        ${!openMenu && styles.main_small} `}
    >
      {mobile && openMenu && (
        <ModalOverlay onClick={() => setOpenMenu(false)} />
      )}
      <section className={`${styles.mainContent}`} onClick={hideNotifications}>
        {!isForum && <Notifications showNotifications={showNotifications} />}
        <div className={`${styles.header}`}>
          <h1 className={`${styles.mainContent__title}`}>
            {getMenuCategories()[activeCategory]}
          </h1>
          {(therapist.usersMultipleCompanies 
            && therapist.usersMultipleCompanies?.length > 1) 
            && <CompaniesCombo />}
          {isTestUser && (
            <button
              type={"button"}
              className={`${styles.mainContent__bell} ${(showNotifications || !mobile) &&
                styles.mainContent__bell_invisible
                }`}
              onClick={() => {
                setShowNotifications(!showNotifications);
              }}
            />
          )}
          <button
            type="button"
            onClick={toggleMenu}
            className={styles.burger}
          />
        </div>
        {children}
      </section>
      <Sidebar
        openMenu={openMenu}
        toggleMenu={toggleMenu}
        changeCategory={changeCategory}
        activeCategory={activeCategory}
      />
    </main>
  );
}
export default MainContentLayout;
